import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "@/lib/utils";

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    variant?: 'default' | 'gradient' | 'success' | 'accent';
  }
>(({ className, value, variant = 'default', ...props }, ref) => {
  const indicatorStyles = {
    default: 'bg-primary',
    gradient: 'bg-gradient-to-r from-primary via-secondary to-primary bg-[length:200%_100%] animate-gradient-shift',
    success: 'bg-gradient-to-r from-success to-secondary',
    accent: 'bg-gradient-to-r from-accent to-warning',
  };

  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn("relative h-3 w-full overflow-hidden rounded-full bg-muted", className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={cn(
          "h-full w-full flex-1 transition-all duration-500 ease-out rounded-full",
          indicatorStyles[variant]
        )}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
});
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
